import React from 'react';
import {
  convertTimestampToDate,
  formatDate,
  useOffer,
} from '../../utils/helpers';

import { PlayIcon } from '../Icons';
import { ButtonLink } from '../common';
import { useVisitId } from '../../hooks/useVisitId';
import useContextToken from '../../hooks/useContextToken';

import './EpisodeRow.scss';

import { IEpisode, IOffer } from '../../utils/models';

// TEALIUM
import initTealiumTracker from 'tealium-tracker';
import AccessServiceBadge from '../AccessServiceBadge';
let tealiumTrackEvent;
if (typeof window !== 'undefined') {
  const { trackEvent } = initTealiumTracker({ debugMode: true });
  tealiumTrackEvent = trackEvent;
}

const renderEpisodeTitle = (episodeNum: number, episodeTitle: string) => {
  if (episodeNum && episodeTitle) {
    return `${episodeNum}. ${episodeTitle}`;
  }

  if (episodeNum) {
    return `Episode ${episodeNum}`;
  }

  if (episodeTitle) {
    return episodeTitle;
  }
};

export interface IEpisodeRowProps {
  episode: IEpisode;
  analytics: any;
  index: number;
}

const EpisodeRow = ({
  episode: {
    id,
    episodeTitle,
    imageUrl,
    episodeNum,
    seasonNum,
    description,
    releaseDate,
    seriesTitle,
    offer,
    accessServices,
  },
  index,
  analytics,
}: IEpisodeRowProps) => {
  const visitId = useVisitId();
  const { contextToken } = useContextToken();

  const quantumTrack = () => {
    analytics.track(
      'SpectrumOnDemand_selectContent_related_tvShows_assetSelection',
      {
        currPageElemUiName: 'tvShows',
        currPageElemIndex: index,
        tmsProgramId: id,
      }
    );
  };

  const handleEpisodeClick = () => {
    analytics.track(
      'SpectrumOnDemand_selectContent_related_tvShows_assetSelection',
      {
        currPageElemUiName: 'tvShows',
        currPageElemIndex: index,
        tmsProgramId: id,
      }
    );
    tealiumTrackEvent({
      linktype: 'tvEpisodeExitToWatch',
      linkname: `${seriesTitle}__episode-${episodeNum}`,
    });
  };

  const { providerId, movieAssetId, startTime, endTime } = useOffer(
    offer as unknown as IOffer[]
  );
  const episodeLink = `https://watch.spectrum.net/ondemand/play/${providerId}::${movieAssetId}?visitId=${visitId}${contextToken}`;

  return (
    <article className="episode-row">
      <a
        href={episodeLink}
        className="episode-row__link desktop"
        aria-label={`Watch ${seriesTitle} - ${
          seasonNum && `Season ${seasonNum}`
        } ${
          episodeNum
            ? `Episode ${episodeNum} ${episodeTitle || ''}`
            : episodeTitle || ''
        }`}
        onClick={handleEpisodeClick}
        // data-linktype="tvEpisodeExitToWatch"
        // data-linkname={`${seriesTitle}__episode-${episodeNum}`}
      >
        <img
          src={`${imageUrl}?twccategory=Iconic&width=374`}
          alt={``}
          width="374"
          height="210"
        />
        <span>
          <PlayIcon /> <span className="link-text">Watch Online</span>
        </span>
      </a>

      <div className="episode-row__content">
        <h3
          className="title"
          aria-label={`${
            episodeNum
              ? `Episode ${episodeNum} ${episodeTitle || ''}`
              : episodeTitle || ''
          }`}
        >
          {renderEpisodeTitle(episodeNum || 0, episodeTitle || '')}
        </h3>
        {/* Start and End Times */}
        <div className="dates">
          {/* Start Time */}
          {startTime && (
            <span className="dates__detail">
              <span className="label">Starts</span>
              {convertTimestampToDate(startTime)}
            </span>
          )}
          {/* Expires */}
          {endTime && (
            <span className="dates__detail">
              <span className="label">Expires</span>
              {convertTimestampToDate(endTime)}
            </span>
          )}
        </div>
        {description && <p className="description">{description}</p>}
        {releaseDate && (
          <h4 className="airdate">Air Date: {formatDate(releaseDate)}</h4>
        )}
        {!!accessServices?.length && (
          <span className="access-services">
            {accessServices.map((serviceType) => (
              <AccessServiceBadge type={serviceType} />
            ))}
          </span>
        )}
      </div>

      <ButtonLink
        type="secondary"
        path={episodeLink}
        className="mobile"
        aria-label={`Watch ${seriesTitle} ${
          episodeNum
            ? `Episode ${episodeNum} ${episodeTitle || ''}`
            : episodeTitle || ''
        }`}
        onClick={quantumTrack}
        // tealiumConfig={{
        //   dataLinkType: 'tvEpisodeExitToWatch',
        //   dataLinkName: `${seriesTitle}__episode-${episodeNum}`,
        // }}
      >
        <>
          <PlayIcon /> <span className="link-text">Watch Online</span>
        </>
      </ButtonLink>
    </article>
  );
};

export default EpisodeRow;
